var aspectRatio = {}

/**
 * Returns new dimensions for a given object, fitting into the container object's dimensions
 * while maintaining its aspect ratio. Both object and container must have width and height properties
 *
 * @param object the object to resize (if necessary)
 * @param container the containing object
 * @returns an object with the new width and height properties, or the original object if no resize was done
 */
aspectRatio.fitToContainer = function(object, container) {
	_validate(object, 'target object')
	_validate(container, 'container object')

	// Fit the height, then the width
	return _fitDimension(_fitDimension(object, container, 'height'), container, 'width')
}

/**
 * Fits the given object into the given container for the given dimension (ie 'height' or 'width')
 */
function _fitDimension(object, container, dim) {
	var otherDim = _otherDim(dim)

	if(container[dim] < object[dim]) {
		var ar = _getAr(object, dim)

		var result = {}
		result[dim] = container[dim]
		result[otherDim] = result[dim] / ar

		return result
	} else {
		return object
	}
}

/**
 * Returns the opposite of the given dimension (ie 'height' returns 'width')
 */
function _otherDim(dim) {
	return dim == 'height' ? 'width' : 'height'
}

/**
 * Validates that the given object is not null and has width/height properties
 */
function _validate(object, objectDescription) {
	if(!object) {
		throw new Error(objectDescription + ' must not be null')
	}

	if(!(_validDim(object.height) && _validDim(object.width))) {
		throw new Error(objectDescription + ' must have a defined and non-null width and height')
	}
}

/**
 * Validations that the given value is not undefined or null (0 is okay, since it's a valid dimension)
 */
function _validDim(dim) {
	return typeof dim !== 'undefined' && dim != null
}

/**
 * Returns the given object's aspect ratio, using the given dimension name as the dividend
 */
function _getAr(object, dividendDim) {
	return object[dividendDim] / object[_otherDim(dividendDim)]
}

export default aspectRatio

aspectRatio.__filename__ = 'dashboards/aspect-ratio.js'
